export default __webpack_public_path__ + "static/media/comment-dots-o.492cdd31.svg";